import React from 'react';
import { SparePiece } from 'react-chessboard';
import { PIECE_COSTS } from '../constants';

export function Shop({
  theme,
  shop,
  money,
  shopGlowActive,
  showShopHint,
  pieceRenderers,
  onReroll,
  onPurchase,
  renderMoneyPill
}) {
  const square = 560 / 8;
  const shopPieces = shop || [];
  const pieceCosts = PIECE_COSTS;

  return (
    <div 
      className={shopGlowActive ? 'gc-glow-blue' : ''} 
      style={{ 
        width: 560, 
        boxSizing: 'border-box', 
        margin: '0 auto 0', 
        border: '1px solid #555', 
        borderRadius: 8, 
        padding: 8, 
        paddingLeft: 16, 
        paddingTop: 0, 
        userSelect: 'none', 
        cursor: 'default' 
      }}
    >
      <div style={{ display: 'flex', alignItems: 'center', marginBottom: 12, minHeight: 28 }}>
        <div style={{ flex: 1, textAlign: 'left', marginTop: 8 }}>
          <span style={{ fontWeight: 700 }}>Shop</span>
          {showShopHint ? (
            <span style={{ marginLeft: 6, color: theme === 'dark' ? '#bbb' : '#777', fontWeight: 400 }}>(click to buy)</span>
          ) : null}
        </div>
        <div style={{ flex: 0, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
          {renderMoneyPill()}
        </div>
        <div style={{ flex: 1 }} />
      </div>
      <div style={{ clear: 'both', display: 'flex', gap: 18, alignItems: 'center' }}>
        <div style={{ width: 64, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
          <div style={{ width: 64, height: 64, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <button
              onClick={onReroll}
              disabled={money < 1}
              title="Reroll ($1)"
              style={{
                width: 48,
                height: 48,
                border: '1px solid #666',
                borderRadius: 100,
                background: 'transparent',
                color: theme === 'dark' ? '#eee' : '#333',
                fontWeight: 700,
                cursor: money < 1 ? 'not-allowed' : 'pointer',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}
            >
              <span style={{ fontSize: 22 }}>↻</span>
            </button>
          </div>
          <div style={{ width: 64, textAlign: 'center', fontSize: 14, fontWeight: 600, color: theme === 'dark' ? '#eee' : '#333', marginTop: 8 }}>$1</div>
        </div>
        <div style={{ display: 'grid', gridTemplateColumns: `repeat(5, ${square}px)`, justifyContent: 'center', columnGap: 18 }}>
          {shopPieces.map((pt, idx) => {
            const cost = pieceCosts[pt[1].toLowerCase()] || 0;
            const affordable = money >= cost;
            const PieceComp = pieceRenderers && pieceRenderers[pt];
            return (
              <div
                key={'shop-'+pt+'-'+idx}
                style={{ 
                  width: `${square}px`, 
                  cursor: affordable ? 'pointer' : 'not-allowed', 
                  display: 'flex', 
                  flexDirection: 'column', 
                  alignItems: 'center', 
                  justifyContent: 'flex-start', 
                  paddingTop: 4, 
                  paddingBottom: 6 
                }}
                onClick={() => affordable && onPurchase(pt, idx)}
                title={`Buy ${pt.substring(1)} ($${cost})`}
              >
                <div style={{ height: `${square}px`, display: 'flex', alignItems: 'center', justifyContent: 'center', pointerEvents: 'none', opacity: affordable ? 1 : 0.4 }}>
                  {PieceComp ? <PieceComp /> : <SparePiece pieceType={pt} />}
                </div>
                <div style={{ fontSize: 14, fontWeight: 600, color: affordable ? (theme === 'dark' ? '#eee' : '#333') : '#999' }}>${cost}</div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}

